export default __webpack_public_path__ + "static/media/mozilla.c1f07743.png";